import React from 'react';
import { DashboardHeader } from '@/src/modules/components/Header';
import { ToastProvider } from '@/src/modules/components/settings/ToastProvider';
import { SubscriptionSection } from '@/src/modules/pages/settings/sections/SubscriptionSection';

export function SubscriptionPage() {
  return (
    <ToastProvider>
      <div className="flex-1 flex flex-col min-h-screen bg-surface-lowest">
        <DashboardHeader
          title="Subscription & Billing"
          description="Manage your current plan, billing history, and payment methods."
        />
        <div className="max-w-4xl mx-auto px-8 py-8 w-full">
          <SubscriptionSection />
        </div>
      </div>
    </ToastProvider>
  );
}
